export default __webpack_public_path__ + "static/Lean-125fe024ce3cb15398663e793d6a7737.png";